import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_CORP_USER, IS_IOS_MOBILE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

// tempexp_18795-start
interface ExcludeTariffsConfig {
    quotas?: number[];
    variant: string;
}

type FeatureType = ExcludeTariffsConfig | undefined;

/** CLOUDWEB-18795: Не продавать тарифы 64/128 гб помесячно на вебвью */
const excludeTariffsMobile: FeatureType = IS_IOS_MOBILE
    ? getFeature('exclude-tariffs-for-free-users-ios')
    : getFeature('exclude-tariffs-for-free-users-and');

export const excludeTariffsForFreeUsers: FeatureType = IS_WEBVIEW && !IS_CORP_USER ? excludeTariffsMobile : undefined;

if (IS_WEBVIEW && excludeTariffsMobile) {
    registerExperiment(
        'exclude-for-free',
        excludeTariffsMobile.variant,
        [
            AnalyticEventNames.TARIFFS_SHOWN,
            AnalyticEventNames.TARIFF_CLICK,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            sendXrayArgs: {
                TARIFFS_SHOWN: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
                TARIFF_CLICK: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
                FAST_CHECKOUT_SHOWN: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
                TARIFF_BUY: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
            },
        }
    );
}
// tempexp_18795-end
